<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	//Design system
	import { Text, Input, Select } from '@Shelly/shelly-design-system';
	//Helpers
	import { capFirstChar, getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';
	//Types
	import type { VirtualComponentInterface } from 'src/types/VirtualComponents';

	export let settings: VirtualComponentInterface['config'];
	export let settingsError: boolean;

	const maxValue = 999999999999999;
	const minValue = maxValue * -1;

	const ensureSettingsUI = () => {
		settings.meta ??= {};
		settings.meta.ui ??= {};
		return settings.meta.ui;
	};

	$: errorMin = getErrorOrInfoMessageForMinAndMax(
		settings.min,
		minValue,
		Math.min(settings.max, maxValue),
	);
	$: errorMax = getErrorOrInfoMessageForMinAndMax(
		settings.max,
		Math.max(settings.min, minValue),
		maxValue,
	);
	$: errorStep = getErrorOrInfoMessageForMinAndMax(
		settings?.meta?.ui?.step,
		0,
		Math.abs(settings.max - settings.min),
	);
	$: errorDefaultValue = getErrorOrInfoMessageForMinAndMax(
		settings.default_value || 0,
		settings.min,
		settings.max,
	);

	$: settingsError =
		errorMin.error != '' ||
		errorMax.error != '' ||
		errorStep.error != '' ||
		errorDefaultValue.error != '';

	const viewOptions = [
		{
			title: capFirstChar(
				$format('virtual_component_label', {
					default: 'label',
				}),
			),
			value: 'label',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_field', {
					default: 'field',
				}),
			),
			value: 'field',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_slider', {
					default: 'slider',
				}),
			),
			value: 'slider',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_progressbar', {
					default: 'progressbar',
				}),
			),
			value: 'progressbar',
		},
		{
			title: capFirstChar(
				$format('virtual_component_label_hidden', {
					default: 'hidden',
				}),
			),
			value: '',
		},
	];
</script>

<Text styleType="h2" class="mb-s">
	{$format('virtual_component_title_view', {
		default: 'View',
	})}
</Text>
<Select
	aria-label={$format('select_view', {
		default: 'Select view',
	})}
	class="width-full mb-m"
	value={viewOptions.find((i) => i.value == settings?.meta?.ui?.view) || viewOptions[0]}
	options={viewOptions}
	icon="fas fa-eye"
	on:change={(e) => {
		ensureSettingsUI().view = e.detail['value'];
	}}
	id="select-6dulqkl"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_min_value', {
		default: 'Min Value',
	})}
</Text>
<Input
	aria-label={$format('input_component_min_value', {
		default: 'Input min Value',
	})}
	size="m"
	class="mb-m"
	maxlength="16"
	icon="fas fa-calculator"
	value={String(settings.min)}
	error={errorMin.error}
	on:input={(e) => (settings.min = e.target['value'])}
	id="input-ttp1tpj"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_max_value', {
		default: 'Max Value',
	})}
</Text>
<Input
	aria-label={$format('input_component_max_value', {
		default: 'Input max Value',
	})}
	size="m"
	class="mb-m"
	maxlength="16"
	icon="fas fa-calculator"
	value={String(settings.max)}
	error={errorMax.error}
	on:input={(e) => (settings.max = e.target['value'])}
	id="input-23edt1y"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_step', {
		default: 'Step',
	})}
</Text>
<Input
	aria-label={$format('input_component_step', {
		default: 'Input step',
	})}
	size="m"
	class="mb-m"
	maxlength="16"
	icon="fas fa-calculator"
	error={errorStep.error}
	value={String(settings?.meta?.ui?.step ?? '')}
	on:input={(e) => {
		ensureSettingsUI().step = e.target['value'];
	}}
	id="input-g5dgqq0"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_unit', {
		default: 'Unit',
	})}
</Text>
<Input
	aria-label={$format('input_component_unit', {
		default: 'Input unit',
	})}
	size="m"
	class="mb-m"
	maxlength="255"
	icon="fas fa-pen"
	value={settings?.meta?.ui?.unit || ''}
	on:input={(e) => {
		ensureSettingsUI().unit = e.target['value'];
	}}
	id="input-7b2azno"
/>

<Text styleType="h2" class="mb-s">
	{$format('sub_settings_title_component_default_value', {
		default: 'Default Value',
	})}
</Text>
<Input
	aria-label={$format('input_component_default_value', {
		default: 'Input default value',
	})}
	size="m"
	class="mb-m"
	icon="fas fa-calculator"
	error={errorDefaultValue.error}
	value={settings.default_value == null ? 0 : settings.default_value}
	on:input={(e) => (settings.default_value = e.target['value'])}
	on:change={(e) => {
		settings.default_value = e.target['value'] || 0;
	}}
	id="input-k11n4h7"
/>
